import { Modal, Stack } from "@mantine/core"
import { useForm } from "@mantine/form"
import { Button, ErrorBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  TransferCertificateRequestRequestDto,
  useTransferCertificateRequest,
} from "~/gen/api"
import { ContactSelect } from "~/pages/SupplierPortal/TraceabilityRequests/components/ContactSelect.tsx"
import { useAuth } from "~/store/auth-context"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

interface Props {
  certificateRequestId: string | undefined
  opened: boolean
  close: () => void
}
export const TransferCertificateRequestModal = ({
  certificateRequestId,
  opened,
  close,
}: Props) => {
  const { t } = useTranslation("traceability")
  const form = useForm<TransferCertificateRequestRequestDto>()

  const {
    mutate,
    isPending: isLoading,
    error,
  } = useTransferCertificateRequest({
    mutation: {
      onSuccess: () => {
        form.reset()
        close()
        showSuccessNotification({
          message: t("transferModal.success"),
          title: t("transferModal.success"),
        })
      },
      onError: (error: unknown) => {
        showAxiosError({
          error: error as Error,
          showNotification: true,
        })
      },
    },
  })
  const { user, isAdmin } = useAuth()

  if (!user?.id) {
    return null
  }
  return (
    <Modal title={t("transferModal.title")} opened={opened} onClose={close}>
      <form onSubmit={form.onSubmit((values) => mutate({ data: values }))}>
        <Stack>
          <ErrorBox error={error} />

          <ContactSelect
            contactId={form.values.contactId}
            onContactSelected={(contactId) => {
              contactId && form.setFieldValue("contactId", contactId)
              certificateRequestId &&
                form.setFieldValue("certificateRequestId", certificateRequestId)
            }}
            userId={user?.id}
            isAdmin={isAdmin}
          />
          <Button type="submit" disabled={!form.isValid()} loading={isLoading}>
            {t("certificates.actions.transfer")}
          </Button>
        </Stack>
      </form>
    </Modal>
  )
}
